import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logoDesktop from '@/assets/betroyale/images/logos/logo-desktop.svg';
import logoMobile from '@/assets/betroyale/images/logos/logo-mobile.svg';
import { THEME_NAME } from '@/constants/themeConfig';

export default function index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image src={logoDesktop} alt={THEME_NAME.betroyale} mx="auto" pb={3} />
      </Show>
      <Hide above="lg">
        <Image src={logoMobile} alt={THEME_NAME.betroyale} h="12" />
      </Hide>
    </Link>
  );
}
